import request from '@/utils/request'
// 获取俱乐部基本信息
export function getCompanyBase (query) {
  return request({
    url: '/company/profile/get',
    method: 'get',
    params: query
  })
}
// 获取公司环境
export function getCompanyEnv (query) {
  return request({
    url: '/company/environment/query',
    method: 'get',
    params: query
  })
}
// 获取公司环境单个
export function getCompanyEnvDetail (query) {
  return request({
    url: '/company/environment/get',
    method: 'get',
    params: query
  })
}
// 获取荣誉
export function getCompanyHonor (query) {
  return request({
    url: '/company/honor/query',
    method: 'get',
    params: query
  })
}
// 获取团员
export function getCompanyMember (query) {
  return request({
    url: '/company/team/query',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/about.js